import React from "react";
import { Box, Typography, Link, Stack, Divider } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LanguageIcon from "@mui/icons-material/Language";
import { SUPPORT } from "../theme";

export default function Footer() {
  const ano = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 3,
        px: 2,
        bgcolor: "#1a2332",
        color: "#cfd8dc",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        sx={{ maxWidth: 1280, mx: "auto" }}
      >
        <Box>
          <Typography variant="subtitle2" sx={{ color: "#fff", fontWeight: 600 }}>
            Otimize Informática
          </Typography>
          <Typography variant="caption">
            © {ano} — Todos os direitos reservados
          </Typography>
        </Box>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
          <Link
            href={`https://wa.me/${SUPPORT.whatsapp}`}
            target="_blank"
            rel="noopener"
            underline="hover"
            sx={{ color: "#cfd8dc", display: "flex", alignItems: "center", gap: 0.5 }}
          >
            <WhatsAppIcon fontSize="small" /> {SUPPORT.whatsappDisplay}
          </Link>
          <Divider orientation="vertical" flexItem sx={{ bgcolor: "#37474f", display: { xs: "none", sm: "block" } }} />
          <Link
            href={`mailto:${SUPPORT.email}`}
            underline="hover"
            sx={{ color: "#cfd8dc", display: "flex", alignItems: "center", gap: 0.5 }}
          >
            <EmailIcon fontSize="small" /> {SUPPORT.email}
          </Link>
          <Divider orientation="vertical" flexItem sx={{ bgcolor: "#37474f", display: { xs: "none", sm: "block" } }} />
          <Link
            href={SUPPORT.site}
            target="_blank"
            rel="noopener"
            underline="hover"
            sx={{ color: "#cfd8dc", display: "flex", alignItems: "center", gap: 0.5 }}
          >
            <LanguageIcon fontSize="small" /> otimizeinformatica.com.br
          </Link>
        </Stack>
      </Stack>
    </Box>
  );
}
